import {
  IServiceDeskL1ListResponseData,
  IServiceDeskL1ListResponseDataL2,
} from "@/api_framework/api_modals/ServiceDesk";
import Input from "@/app/components/ui/Inputs/Input";
import InputWithFileUpload from "@/app/components/ui/Inputs/InputWithFileUpload";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import MandatoryLabel from "@/app/components/ui/Reusable/MandatoryLabel";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import SkeletonType1 from "@/app/components/ui/Skeletons/Type1";
import { useSearchCustomerAPI } from "@/app/hooks/api_hooks/customer_profile/useSearchCustomerAPI";
import { useServiceDeskCreateRaiseAPI } from "@/app/hooks/api_hooks/service_desk/useServiceDeskCreateRaiseAPI";
import { useServiceDeskResonsL1API } from "@/app/hooks/api_hooks/service_desk/useServiceDeskResonsL1API";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useUtils } from "@/app/hooks/useUtils";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { TrashIcon } from "@heroicons/react/24/outline";

import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { BiDownload } from "react-icons/bi";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { PRIMARY_BUTTON } from "@/constants";

const ticketReqirement = [
  { id: "1", title: "Service Desk Action required" },
  { id: "2", title: "Issue Resolved at Sales end" },
  { id: "3", title: "Issue Resolved at Clinic end" },
];
export interface IServiceDeskImage {
  base_64_string: string;
  file_extension: string;
  file_name: string;
  is_thumbnail?: boolean;
  image_url?: string;
}

export interface IServiceRaiseIssueProps {
  user_id: string;
  user_name: string;
  // pet_name?: string;
  l1_id: number;
  l2_id: number;
  l1_heading: string;
  l2_heading: string;
  pet_id?: string;
  escalation_note: string;
  l1_mapping: string;
  ticket_requirementId?: string;
  raised_by?: string;
  ticket_requirement?: string;
  l2_mapping: string;
  attachment?: IServiceDeskImage[];
}
export interface IServiceFiltersFormFields {
  clinic: string;
  user: string;
  describe?: string;
  ticket_requirementId?: string;
  ticket_requirement?: string;
  l1_issue?: string;
  l2_issue?: string;
  l1_item?: string;
  l2_item?: string;
  attachment_file: FileList;
  image: IServiceDeskImage[];
}

const ServiceDeskRaiseIssue = () => {
  const { forAlphaNumeric } = useFormValidations();
  const { NO_PWL_RESULTS } = useImageConstants();
  const { fileListToBase64, handleBase64ToImageDownload } = useUtils();

  const { execute: searchCustomer, searchResults } = useSearchCustomerAPI();
  const { execute: fetchReasonList, reasonsList } = useServiceDeskResonsL1API();
  const { execute: createIssueAPI } = useServiceDeskCreateRaiseAPI();

  const [error, setError] = useState<boolean>(false);
  const [params, _setParams] = useSearchParams();

  const [selectedPetId, setSelectedPetId] = useState<string | null>(null);
  const [reasonsListl2, setReasonsListl2] = useState<IServiceDeskL1ListResponseDataL2[]>([]);

  const isCustomerSearchInProgress = useLoader("isCustomerSearchInProgress");
  const user = useAppSelector((state) => state?.auth?.userLoginInfo);

  const formHook = useForm<IServiceFiltersFormFields>({
    mode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    fetchReasonList();
  }, []);

  const navigate = useNavigate();

  function filterL1ListById(l1List: IServiceDeskL1ListResponseData[], id: number) {
    return l1List.find((item) => item.l1_id === id);
  }
  function filterL1ListByIdl2(l2List: IServiceDeskL1ListResponseDataL2[], id: number) {
    return l2List.find((item) => item.l2_id === id);
  }

  const attachementFieldHook = useFieldArray<IServiceFiltersFormFields>({
    name: "image",
    control: formHook.control,
  });

  const onSubmit = (data: IServiceFiltersFormFields) => {
    // const l1maping=l1List.find((item) => item.l1_id === id)

    const selectedL1 = filterL1ListById(reasonsList, parseInt(data.l1_issue));
    const selectedL2mapping = filterL1ListByIdl2(reasonsListl2, parseInt(data.l2_issue));
    const pet_name: any = searchResults?.filter((item) => item.pet_details?.pet_id === selectedPetId);
    const constructedBody: IServiceRaiseIssueProps = {
      user_id: searchResults[0]?.customer_details?.user_id,
      pet_id: selectedPetId,
      user_name: searchResults[0]?.customer_details?.name,
      l1_id: parseInt(data.l1_issue),
      l1_heading: data.l1_item,
      l2_id: parseInt(data.l2_issue),
      l2_heading: data.l2_item,
      l1_mapping: selectedL1?.l1_mapping,
      l2_mapping: selectedL2mapping?.l2_mapping,
      escalation_note: `issue is for ${pet_name?.length > 0 && pet_name[0]?.pet_details?.name} : ${data.describe}`,
      attachment: data.image,
      ticket_requirement: data.ticket_requirement,
      raised_by: user?.email ? user?.email : localStorage.getItem("user_email"),
    };
    createIssueAPI(constructedBody).then(({ status }) => {
      if (status) {
        navigate("/app/service-desk/issue-list");
      }
    });
  };

  // Update L2 list based on selected L1 issue

  useEffect(() => {
    const l1Id = formHook.getValues("l1_issue");
    if (l1Id) {
      // Convert l1Id from string to number for comparison
      const selectedL1 = filterL1ListById(reasonsList, parseInt(l1Id));

      if (selectedL1) {
        setReasonsListl2(selectedL1?.l2_list);
      } else {
        setReasonsListl2([]);
      }
    } else {
      setReasonsListl2([]);
    }
  }, [formHook.watch("l1_issue"), reasonsList]);

  const reasonsListItem = useSelectMenuReducer(reasonsList, "l1_heading", "l1_id");
  const reasonsListItemL2 = useSelectMenuReducer(reasonsListl2, "l2_heading", "l2_id");

  const handleSearch = () => {
    const query = formHook.getValues("user");
    if (query !== "") {
      searchCustomer(formHook.watch("user"), "0");
      setError(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    const mobile = params.get("mobile");
    if (mobile) {
      searchCustomer(mobile, "0");
      formHook.setValue("user", mobile);
    }
  }, [params.get("mobile")]);

  useEffect(() => {
    if (searchResults?.length > 0) {
      setSelectedPetId(searchResults[0]?.pet_details?.pet_id);
    }
  }, [searchResults]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPetId(event.target.value);
  };

  const handleConvertFilesAndSetInForm = async () => {
    const existingFiles = formHook.getValues("image") || [];
    const newFiles = await fileListToBase64(formHook.getValues("attachment_file"));

    const updatedFiles = [...existingFiles, ...newFiles];
    formHook.setValue("image", updatedFiles);
  };

  useEffect(() => {
    const files = formHook.getValues("attachment_file");
    if (files?.length > 0) {
      handleConvertFilesAndSetInForm();
    }
  }, [formHook.watch("attachment_file")]);

  return (
    <div className="bg-white p-3 sm:p-5 pb-20 sm:pb-28 min-h-screen">
      <div className="flex justify-between items-center bg-white py-3 rounded-lg">
        <h2 className="font-semibold text-black">Need Help</h2>
      </div>

      <div className="my-2 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <p className="shrink-0 sm:w-40">Search Customer</p>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-auto">
              <Input
                required
                className="w-full sm:w-72 text-xs"
                // className styles the wrapper; the field needs its own height or
                // sm:leading-6 makes it shorter on mobile than the button beside it.
                inputClassName="h-9"
                placeholder="Please Search With Mobile Number"
                maxLength={10}
                register={formHook.register("user", {
                  required: true,
                  ...forAlphaNumeric.validations,
                })}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    handleSearch();
                  }
                }}
                fieldError={formHook.formState.errors.user}
                errorMessages={[forAlphaNumeric.errors, { message: "Number is required", type: "required" }]}
              />
              {error && <span className="mt-1 block text-red-400 text-[10px]">Please Enter a value</span>}
            </div>
            <button
              className={`${PRIMARY_BUTTON} w-full sm:w-auto`}
              onClick={() => {
                handleSearch();
              }}
            >
              Search
            </button>
        </div>
      </div>
      {isCustomerSearchInProgress ? (
        <SkeletonType1 />
      ) : (
        <form className="flex flex-col gap-4 grid-cols-3 py-4 w-auto" onSubmit={formHook.handleSubmit(onSubmit)}>
          {searchResults[0]?.customer_details?.name ? (
            <div>
              <div className="py-4">
                <p className="py-2 font-medium text-black text-sm">
                  Raise issue for : {searchResults[0]?.customer_details?.name}
                </p>
                <p>Phone Number: {searchResults[0]?.customer_details?.mobile}</p>
                <div className="my-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-8">
                  <p className="py-1">
                    Please Select the pet <span className="text-red-400">*</span> :
                  </p>
                  <div className="flex flex-wrap items-center gap-4">
                    {searchResults?.map((item) => {
                      const petId = item?.pet_details?.pet_id; // Assuming you have a unique identifier like pet_id

                      return (
                        <div key={petId} className="flex items-center">
                          <input
                            checked={selectedPetId === petId}
                            onChange={handleChange}
                            id={petId}
                            name="selected-pet"
                            value={petId}
                            type="radio"
                            className={`h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600 ${
                              selectedPetId === petId ? "bg-black" : ""
                            }`}
                            aria-describedby={`${petId}-description`}
                          />
                          <label
                            htmlFor={petId}
                            className="block ml-3 font-medium text-gray-900 text-sm hover:text-indigo-500 leading-6 transition-colors"
                          >
                            {item?.pet_details?.name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="py-3">
                  <p className="py-1">
                    How can we help you today? <span className="text-red-400">*</span>
                  </p>
                  <SearchableSelectMenu
                    errorMessages={[{ message: "Clinic is provider", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("l1_issue", item.id);
                        formHook.setValue("l1_item", item.title);
                      }
                    }}
                    fieldError={formHook.formState.errors.l1_issue}
                    register={formHook.register("l1_issue", { required: true })}
                    selectItems={reasonsListItem}
                    placeholder="Choose type of issue"
                    showTooltips={false}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    defaultSelected={reasonsListItem?.filter((oc) => oc.title === formHook.watch("l1_issue"))[0]}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full sm:w-1/3"
                    showDropdownWhenNoData
                  />
                </div>
                <div className="my-3">
                  <p className="py-1">
                    What issue are you facing? <span className="text-red-400">*</span>
                  </p>
                  <SearchableSelectMenu
                    errorMessages={[{ message: "Clinic is provider", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("l2_issue", item.id);
                        formHook.setValue("l2_item", item.title);
                      }
                    }}
                    fieldError={formHook.formState.errors.l2_issue}
                    register={formHook.register("l2_issue", { required: true })}
                    selectItems={reasonsListItemL2}
                    placeholder="Choose type of issue"
                    showTooltips={false}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    defaultSelected={reasonsListItemL2?.filter((oc) => oc.title === formHook.watch("l2_issue"))[0]}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full sm:w-1/3"
                    showDropdownWhenNoData
                  />
                </div>
                <div className="my-3">
                  <p className="py-1">
                    Ticket requirement? <span className="text-red-400">*</span>
                  </p>
                  <SearchableSelectMenu
                    errorMessages={[{ message: "Clinic is provider", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("ticket_requirementId", item.id);
                        formHook.setValue("ticket_requirement", item.title);
                      }
                    }}
                    fieldError={formHook.formState.errors.ticket_requirement}
                    register={formHook.register("ticket_requirement", { required: true })}
                    selectItems={ticketReqirement}
                    placeholder="Choose Ticket requirement"
                    showTooltips={false}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    defaultSelected={
                      ticketReqirement?.filter((oc) => oc.title === formHook.watch("ticket_requirement"))[0]
                    }
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full sm:w-1/3"
                    showDropdownWhenNoData
                  />
                </div>
                <div className="my-3">
                  <p className="py-1">Describe your issue</p>
                  <textarea
                    rows={5}
                    placeholder="Describe issue here..."
                    {...formHook.register("describe", { required: false })}
                    className="block border-gray-300 shadow-sm py-1.5 border rounded-md w-full sm:w-1/3 text-gray-900 text-xs"
                    defaultValue={""}
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-start items-center col-span-1 text-xs">
                    <MandatoryLabel label="Attachment" />
                  </div>
                  <div className="col-span-4 flex w-full flex-col items-start sm:w-1/3">
                    <InputWithFileUpload
                      variant="DRAG_AND_DROP"
                      fieldError={formHook.formState.errors.attachment_file ?? {}}
                      {...formHook.register("attachment_file")}
                      register={formHook.register("attachment_file", {
                        validate: {
                          maxSize: (files: FileList) => {
                            return (
                              Array.from(files).every((file) => file.size < 5 * 1024 * 1024) ||
                              "Each file must be smaller than 5MB"
                            );
                          },
                          fileType: (files: FileList) => {
                            const validTypes = ["image/png", "image/jpeg", "application/pdf"];
                            return (
                              Array.from(files).every((file) => validTypes.includes(file.type)) || "Invalid file type"
                            );
                          },
                        },
                      })}
                      isMultiple
                      onClear={() => {
                        formHook.resetField("attachment_file");
                      }}
                      type="file"
                      className="w-full [&_label]:!text-gray-700 [&_label]:hover:!text-gray-900 [&_label]:!ring-gray-400 [&_.bg-blue-50]:!bg-gray-100"
                      id="attachment_file"
                      errorMessages={[{ type: "", message: "Please upload Issues" }]}
                      dragAndDropDescription={{ allowedFormats: ["PDF", "JPEG", "PNG"], maxFileSize: "5MB" }}
                    />
                    <div>
                      {attachementFieldHook.fields.map((file, index) => (
                        <div key={file.id} className="mt-2 flex w-full items-center gap-3 py-2 text-xs">
                          <div className="flex min-w-0 flex-1 items-center gap-1">
                            <p className="truncate">{formHook.getValues(`image.${index}.file_name`)}</p>
                          </div>
                          <button
                            type="button"
                            onClick={() =>
                              handleBase64ToImageDownload(
                                formHook.getValues(`image.${index}.base_64_string`),
                                formHook.getValues(`image.${index}.file_name`),
                                formHook.getValues(`image.${index}.file_extension`),
                              )
                            }
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <BiDownload className="w-4 h-4" />
                          </button>
                          <button
                            type="button"
                            onClick={() => attachementFieldHook.remove(index)}
                            className="text-gray-500 hover:text-red-500"
                          >
                            <TrashIcon className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end p-4 gap-4 items-center w-full border-t-2 right-0 bottom-0 fixed bg-white">
                <button type="submit" className={PRIMARY_BUTTON}>
                  Raise Ticket
                </button>
              </div>
            </div>
          ) : (
            <NoDataFoundComponent
              imageURL={NO_PWL_RESULTS}
              message="No Users Found"
              description="No users found for the given number, try again"
            />
          )}
        </form>
      )}
    </div>
  );
};

export default ServiceDeskRaiseIssue;
